import { Component, OnInit, inject, signal } from '@angular/core';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { CommonModule } from '@angular/common';
import { OrderDto, OrderService } from '@/app/pages/service/order.service';

@Component({
    standalone: true,
    selector: 'app-recent-sales-widget',
    imports: [CommonModule, TableModule, ButtonModule, RippleModule, TagModule],
    template: `<div class="card mb-8!">
        <div class="font-semibold text-xl mb-4">Recent Sales</div>
        <p-table [value]="orders()" [paginator]="true" [rows]="5" responsiveLayout="scroll">
            <ng-template #header>
                <tr>
                    <th>Order #</th>
                    <th pSortableColumn="customerName">Customer <p-sortIcon field="customerName"></p-sortIcon></th>
                    <th pSortableColumn="total">Total <p-sortIcon field="total"></p-sortIcon></th>
                    <th>Status</th>
                    <th pSortableColumn="createdAt">Date <p-sortIcon field="createdAt"></p-sortIcon></th>
                </tr>
            </ng-template>
            <ng-template #body let-order>
                <tr>
                    <td style="width: 20%; min-width: 8rem;" class="font-semibold">{{ order.orderNumber }}</td>
                    <td style="width: 30%; min-width: 8rem;">{{ order.customerName }}</td>
                    <td style="width: 20%; min-width: 7rem;">{{ order.total | currency:'EGP':'symbol':'1.0-0' }}</td>
                    <td style="width: 15%;">
                        <p-tag [value]="order.status" [severity]="getStatusSeverity(order.status)" />
                    </td>
                    <td style="width: 15%; min-width: 8rem;">{{ order.createdAt | date:'dd MMM, HH:mm' }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>`,
    providers: [OrderService]
})
export class RecentSalesWidget implements OnInit {
    orders = signal<OrderDto[]>([]);

    private orderService = inject(OrderService);

    ngOnInit() {
        this.orderService.getAll().subscribe({
            next: (data) => {
                const sorted = [...data].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
                this.orders.set(sorted);
            },
            error: () => {}
        });
    }

    getStatusSeverity(status: string): 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast' {
        switch (status?.toLowerCase()) {
            case 'pending': return 'warn';
            case 'paid': return 'success';
            case 'processing': return 'info';
            case 'shipped': return 'info';
            case 'delivered': return 'success';
            case 'cancelled': return 'danger';
            case 'refunded': return 'secondary';
            default: return 'secondary';
        }
    }
}
